import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import loadAndRunCookieScript from '../utils/loadCookieScript';
const links_list = ['Terms of Use', 'Privacy Policy', 'Imprint', 'About'];
const copyright = '\u00A9 1999-2025 Infineon Technologies AG';
const Footer = ({ links }) => {
    useEffect(() => {
        const domainScript = process.env.VITE_ONETRUST_DOMAIN_ID;
        if (!domainScript) {
            console.warn('OneTrust domain script ID missing. Set VITE_ONETRUST_DOMAIN_ID in env.');
        }
        else if (!document.querySelector('script[data-domain-script]')) {
            const s = document.createElement('script');
            s.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
            s.type = 'text/javascript';
            s.charset = 'UTF-8';
            s.setAttribute('data-domain-script', domainScript);
            s.setAttribute('data-document-language', 'true');
            document.head.appendChild(s);
        }
        window.OptanonWrapper = function () { };
    }, []);
    return (_jsxs("div", { className: "footer-container", children: [links_list.map((link, index) => (_jsxs("span", { children: [_jsx("a", { className: "footer-link", href: links[link], target: "_blank", rel: "noopener noreferrer", children: link }), _jsx("span", { className: "footer-seperator", children: index < links_list.length && ' | ' })] }, index))), _jsx("span", { children: _jsx("a", { className: "footer-link", onClick: loadAndRunCookieScript, children: "Cookies" }) }), _jsx("span", { className: "footer-copyright-spearator", children: '|' }), _jsx("span", { className: "footer-link", children: copyright })] }));
};
export default Footer;
